import { render, staticRenderFns } from "./component-user-account.vue?vue&type=template&id=6db99f2c&scoped=true"
import script from "./component-user-account.vue?vue&type=script&lang=js"
export * from "./component-user-account.vue?vue&type=script&lang=js"
import style0 from "./component-user-account.vue?vue&type=style&index=0&id=6db99f2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db99f2c",
  null
  
)

export default component.exports